import request from '@/utils/request'

// 获取SKU详情
export function getSkuDetail(id) {
    return request({
        url: '/admin/goodsSku/detail?id=' + id,
        method: 'get'
    })
}

// 根据商品ID查询SKU列表
export function listSkusByGoodsId(goodsId) {
    return request({
        url: '/admin/goodsSku/listByGoodsId?goodsId=' + goodsId,
        method: 'get'
    })
}

// 新增SKU
export function insertSku(data) {
    return request({
        url: '/admin/goodsSku/insert',
        method: 'post',
        data: data
    })
}

// 修改SKU
export function updateSku(data) {
    return request({
        url: '/admin/goodsSku/update',
        method: 'post',
        data: data
    })
}

// 删除SKU
export function deleteSku(id) {
    return request({
        url: '/admin/goodsSku/delete?id=' + id,
        method: 'post'
    })
}

// 批量保存SKU
export function batchInsertSkus(data) {
    return request({
        url: '/admin/goodsSku/batchInsert',
        method: 'post',
        data: data
    })
}

// 根据商品ID删除所有SKU
export function deleteSkusByGoodsId(goodsId) {
    return request({
        url: '/admin/goodsSku/deleteByGoodsId?goodsId=' + goodsId,
        method: 'post'
    })
}
